import { IGetItensChecklistByIdUseCase } from "../../../presentation/useCases/read/get_itens_checklist_by_id_use_case";
import { GetItensChecklistByIdResponseModels } from "../../models/items_checklist_model";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetItensChecklistByIdUseCase
 */

export class GetItensChecklistByIdUseCase implements IGetItensChecklistByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async getItensChecklistById(id: number): Promise<GetItensChecklistByIdResponseModels> {
    return await this.repository.getByIdItensChecklist(id);
  }
}
